import { AudioManager } from "../../AudioManager";
import { HelpParameters, Help, HelpPanelColor} from "../../help/Help";
import { IHelpFactory } from "../../help/IHelpFactory";
import { MultigameParams } from "../../MultigameParams";
import { SlotGameInitData } from "../../SlotGameInitData";
// import { IPanelFactory, PanelParams } from "../panel/IPanelFactory";
// import { Panel, ButtonColors } from "../panel/panel";
import { RewardColor } from "../ScatterRandomAward/RewardOptionFactory";
import { SlotGameType1_Responsive } from "../SlotGameType1_Responsive";
import { MarkersInfoColors } from "../WinLineInfoMarkers";
import { IWinLinesFactory } from "../WinLines/IWinLinesFactory";
import { SquareWinLinesFactory } from "../WinLines/SquareWinLineFactory";
// namespace SlotGames {
export class SecretsOfAnubisClassic_Responsive extends SlotGameType1_Responsive {
    // override default factory with one that creates custom anubis freegame


    protected override helpFactory: IHelpFactory = new SecretsOfAnubisClassicHelpFactory();
    //LED COLOR
    protected override ColorLed: string = "205,164,52\n";
    constructor(multigameParams: MultigameParams, initData: SlotGameInitData, gameName: string = "SecretsOfAnubisClassic") {
        super(multigameParams, initData, gameName);

        this.spinnableReelsParams.topBorderWidth = 6;
        this.spinnableReelsParams.bottomBorderWidth = 6;
    }


    protected override colorLineMarkers: MarkersInfoColors =
        {
            MarkerbackgroundColor: "linear-gradient(90deg,rgb(89,19,13),rgb(89,44,18), rgb(89,44,18),rgb(89,44,18),rgb(89,19,13)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };
}

//Help Colorized
class SecretsOfAnubisClassicHelpFactory implements IHelpFactory {
    public CreateNewHelp(params: HelpParameters): Help {
        return new SecretsOfAnubisClassicHelp(params);
    }
}

class SecretsOfAnubisClassicHelp extends Help {
    protected override BackgroundPanel(): HelpPanelColor {
        let color: HelpPanelColor = {
            backgroundPanelColor: "linear-gradient(rgb(89,19,13),rgb(89,44,18), rgb(89,44,18),rgb(89,44,18),rgb(89,19,13)), linear-gradient( #BF953F, #FCF6BA, #B38728, #FBF5B7, #AA771C)",
        };

        return color;
    }
}

// }



